import React from "react"
import PropTypes from "prop-types"

import Header from "./header"
import Footer from "./footer"
import styles from "../styles/components/layout.module.scss"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const Layout = ({ margin = true, children }) => {
  return (
    <>
      <Header />
      <ToastContainer autoClose={2000} />

      <div className={styles.layout} style={!margin ? { marginTop: 0 } : {}}>
        <main>{children}</main>
      </div>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
